// developer api data types
export const GET_DEVELOPER_API_DATA_REQUEST = "GET_DEVELOPER_API_DATA_REQUEST"
export const GET_DEVELOPER_API_DATA_SUCCESS = "GET_DEVELOPER_API_DATA_SUCCESS"
export const GET_DEVELOPER_API_DATA_ERROR = "GET_DEVELOPER_API_DATA_ERROR"

//generate api key
export const GENERATE_API_KEY_REQUEST = "GENERATE_API_KEY_REQUEST"
export const GENERATE_API_KEY_SUCCESS = "GENERATE_API_KEY_SUCCESS"
export const GENERATE_API_KEY_ERROR = "GENERATE_API_KEY_ERROR"
